import * as React from 'react';
import {
  Box,
  Button,
  Chip,
  Link,
  Skeleton,
  Typography,
} from '@mui/material';
import { BackArrowIcon, ExportIcon, PaymentReceiptIcon, } from '../icons';
import { GlobalStyles } from '@mui/material';
import AdmissionModal from '../components/Admission/AdmissionModal';
import { useState } from 'react';
import ThreeDotMenuEditDelete from '../components/ThreeDotMenuEditDelete';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNotification } from '../hooks/useNotification';
import { deleteAdmissionById, downloadAdmissionList, fetchAllAdmissionList } from '../api/admissionApi';
import CommonFilterTab from '../components/common/CommonFilterTab';
import CommonDataTable from '../components/common/CommonDataTable';
import { setFilterField } from '../containers/filter-container/reducer/filterSlice';
import { defaultPaginationValues, filterTypeOptions, paymentStatusList } from '../utils/constant';
import { formatMultiQueryParams, jsonParserFormatter } from '../utils/helperFunction';
import { fetchUniversitiesNames } from '../api/universityApi';
import { fetchCourseNameList } from '../api/courseApi';
import { fetchSpecializationsNameSuggestion } from '../api/specializationApi';

const formIntiatlValue = { fullName: "", phone: "", email: "", universityId: "", courseNameId: "", specializationNameId: "", paymentStatus: "", receipt: "", courseFee: {}, paidAmt: {} }

const Admission = () => {
  const filterSlice = useSelector(state => state.filter?.filters)
  const LOCATION_FILTER = `filters:${window.location.pathname}`
  const dispatch = useDispatch()
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [admissionOpen, setAdmissionOpen] = useState(false);
  const [rowCount, setRowCount] = React.useState(0);
  const { showSuccessNotification, showErrorNotification, } = useNotification()
  const [deleting, setDeleting] = useState(false)
  const [pageFilters, setPageFilters] = React.useState(defaultPaginationValues);
  const [isRender, setIsRender] = React.useState(false)
  const [searchFilter, setSearchFilter] = React.useState({})
  const [formData, setFormData] = useState(formIntiatlValue)
  const [universitySuggestion, setUniversitySuggesion] = React.useState([])
  const [courseSuggestion, setCourseSuggestion] = React.useState([])
  const [specializationSuggestion, setSpecializationSuggestion] = React.useState([])
      const [downloading, setDownloading] = React.useState(false)

  const handleClose = () => setAdmissionOpen(false);
  const handleOpen = () => { setAdmissionOpen(true); setFormData(formIntiatlValue) };

  const handleFliterSliceChange = (values = {}, isReset = false) => {
    let isQuery = typeof values === "object" && Object.keys(values)?.length
    isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
  }

  const fetchDetails = () => {
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchAllAdmissionList({ setRows, filterData: { ...searchFilter, ...multiFilter, isMultiFilter: true }, setRowCount, setLoading })
      .catch(error => {
        showErrorNotification(error?.message)
      })
  }


  const deleteAdmission = (admissionId) => {
    if (!admissionId || deleting) return
    deleteAdmissionById({ setDeleting, admissionId })
      .then(res => {
        showSuccessNotification("Successfully deleted")
        fetchDetails()
      })
      .catch(error => {
        showErrorNotification(error?.message)
      })
  }

  const handleActionChange = (id, type, value) => {
    if (!id || !value) return
    const actionType = value?.toLowerCase()
    if (actionType === "edit") {
      setAdmissionOpen(true)
      const editRow = rows.find(ele => ele?.id === id)
      if (editRow) {
        setFormData(editRow)
      }
    } else if (actionType === "delete") {
      deleteAdmission(id)
    }
  };

  const handleFileClick = (fileUrl) => {
    if (!fileUrl) return
    window.open(fileUrl, '_blank', 'noopener,noreferrer');
  }

    const downloadAdmissionDetails = () => {
    if (downloading) return
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    downloadAdmissionList({ setDownloading, filterData: {...searchFilter, ...multiFilter, isMultiFilter: true,isDownload:true } })
      .then(res => {
        showSuccessNotification("Successfully downloaded")
      }).catch(error => {
        showErrorNotification(error?.message)
      })
  }

  // Status colors mapping
  const paymentTypeStyles = {
    Partial: {
      text: '#fff', // Dark green
      bg: '#FF81FF',   // Light green
    },
    EMI: {
      text: '#fff', // Orange
      bg: '#7367F0',   // Light orange
    },
    Full: {
      text: '#fff', // Dark red
      bg: '#098B34',   // Light red
    },
  };


  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      // renderCell: (params) => rows?.findIndex((r) => r.id === params.row.id) + 1,
    },
    {
      field: 'studentID',
      headerName: 'Student ID',
      flex: 1,
      minWidth: 130,
      cellClassName: 'sticky-col-1',
      headerClassName: 'sticky-col-1',
      filterColumnName: "studentId",
      filterType: filterTypeOptions.string,
    },

    {
      field: 'fullName',
      headerName: 'Student Name',
      flex: 1.2,
      minWidth: 160,
      filterColumnName: "user.fullName",
      filterType: filterTypeOptions.string,
      renderCell: (params) => (
        <Box
          sx={{
            fontWeight: 'bold',
            color: '#1075FF',
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: 'phone',
      headerName: 'Mobile No.',
      flex: 1.2,
      minWidth: 160,
      cellClassName: 'fw-bold',
      filterColumnName: "user.phone",
      filterType: filterTypeOptions.string,
    },
    {
      field: 'university',
      headerName: 'University',
      flex: 2,
      minWidth: 260,
      filterColumnName: "university.universityName",
      filterType: filterTypeOptions.selection,
      selection: universitySuggestion,
      renderCell: (params) => {
        const { logo, university, university_ID } = params.row;
        const displayName = university;

        const getInitials = (fullName) => {
          if (!fullName) return '';
          const words = fullName.trim().split(' ').filter(Boolean);
          if (words.length === 1) return words[0][0]?.toUpperCase() || '';
          if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
          return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
        };

        const stringToColor = (str) => {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
          }
          const c = (hash & 0x00ffffff).toString(16).toUpperCase();
          return '#' + '00000'.substring(0, 6 - c.length) + c;
        };

        const bgColor = stringToColor(displayName || 'University');

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box display="flex" alignItems="center" gap={1} sx={{ height: '100%' }}>
            {logo ? (
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{
                  width: 40,
                  height: 40,
                  padding: '5px',
                  borderRadius: '50%',
                  objectFit: 'contain',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                  display: 'block',
                  maxHeight: 60,
                }}
              />
            ) : (
              <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: bgColor,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '10px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(displayName)}
              </Box>
            )}
            <Box>
              <Typography sx={{ fontSize: '13px !important', fontWeight: 500 }}>
                {displayName}
              </Typography>
              {params.row.universityNote && (
                <Typography sx={{ fontSize: '11px !important', fontWeight: '500', color: '#363853' }}>
                  ({params.row.universityNote})
                </Typography>
              )}
              <Typography
                sx={{ fontSize: '11px !important', fontWeight: '500', color: '#6E7485', paddingTop: '4px' }}
              >
                University ID: {university_ID}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'course',
      headerName: 'Course',
      flex: 1,
      minWidth: 130,
      filterColumnName: "course.name",
      filterType: filterTypeOptions.selection,
      selection: courseSuggestion,
    },
    {
      field: 'specialization',
      headerName: 'Specialization',
      flex: 1,
      minWidth: 250,
      filterColumnName: "specialization.name",
      filterType: filterTypeOptions.selection,
      selection: specializationSuggestion,
    },
    {
      field: 'fees',
      headerName: 'Fees',
      flex: 1,
      minWidth: 130,
      cellClassName: "fw-bold",
      filterColumnName: "courseFee.amount",
      filterType: filterTypeOptions.numberRange,
    },
    {
      field: 'paymentType',
      headerName: 'Payment Type',
      flex: 1,
      minWidth: 130,
      cellClassName: "fw-bold text-center",
      filterColumnName: "paymentStatus",
      filterType: filterTypeOptions.selection,
      selection: paymentStatusList,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={70} />
        ) : (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: paymentTypeStyles[params.value]?.bg || '#eee',
              color: paymentTypeStyles[params.value]?.text || '#000',
              fontWeight: 500,
            }}
          />
        ),
    },
    {
      field: 'receipt',
      headerName: 'Payment Receipt',
      flex: 1,
      minWidth: 130,
      filterable: false,
      renderCell: (params) => {
        const fileUrl = params?.row?.receipt
        return <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
          onClick={() => handleFileClick(fileUrl)}
        >
          {fileUrl && <PaymentReceiptIcon />}
        </Box>
      },

    },
    {
      field: 'enrollmentDate',
      headerName: 'Enrollment Date',
      flex: 1,
      minWidth: 130,
      cellClassName: "fw-bold",
      filterColumnName: "createdAt",
      filterType: filterTypeOptions.dateRange,

    },
    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      filterable: false,
      renderCell: (params) =>
        loading ? <Skeleton width={80} /> : <ThreeDotMenuEditDelete rowId={params.row.id} onAction={handleActionChange} />,
    },
  ];

  React.useEffect(() => {
    fetchDetails()
  }, [filterSlice[LOCATION_FILTER], isRender])

  // handle extra filter tabs changes
  React.useEffect(() => {
    if (pageFilters?.page) {
      handleFliterSliceChange({ page: 0 })
    } else {
      setIsRender(!isRender)
    }
  }, [searchFilter])

  // parse page filters
  React.useEffect(() => {
    const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
    setPageFilters(values)
  }, [filterSlice[LOCATION_FILTER]])

    // load course/ universities for filter suggestions
    React.useEffect(() => {
      fetchUniversitiesNames((result) => setUniversitySuggesion(result?.map(item => ({ ...item, value: item?.label }))))
        .catch(err => console.log("error:---", err))
  
      fetchCourseNameList((result) => { setCourseSuggestion(result?.map(el => ({ label: el?.course, value: el?.course }))) }, { skipLimit: true })
        .catch(() => { })
  
      fetchSpecializationsNameSuggestion((result) => { setSpecializationSuggestion(result?.map(el => ({ ...el, value: el?.label }))) }, { skipLimit: true })
        .catch(() => { })
    }, [])


  return (
    <>
      {/* Apply global styles to DataGrid dropdown menus */}
      {/* <GlobalStyles
        styles={{
          '.MuiDataGrid-menuList': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiDataGrid-panelContent': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiSelect-select': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiList-root .MuiButtonBase-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
            fontSize: '13px',
          },
          '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiTypography-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root': {
            fontSize: '13px',
            padding: '6px 12px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
            backgroundColor: '#f5f5f5',
          },
          '& .MuiDataGrid-columnHeaders': {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: '#fff',
          },
          '& .MuiDataGrid-cell.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 2,
          },
          '& .MuiDataGrid-columnHeader.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 3, // slightly higher than cell
          },
        }}
      /> */}

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', marginBottom: '12px' }}>
          <div className="row align-items-center">
            <div className="col">
              <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/university-listing-management" className='d-flex'><BackArrowIcon /></Link>Admission</Typography>
            </div>
            {/* End Col */}
            <div className="col">
              <Box display="flex" gap={2} sx={{ justifyContent: 'end' }}>
                <Button
                  onClick={handleOpen}
                  sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize' }}
                >
                  + Add New Admission
                </Button>
              </Box>
            </div>
          </div>
          {/* End Col */}
        </div>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            my: 0,
            px: 2,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
        </Box>




        {/* Filter Toolbar */}
        <CommonFilterTab type='admission' module='admission' searchPlaceholder='Search ID/Mobile/Name...' detailType='All Admitted Students' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} isExportBtn={true} isExporting={downloading} handleExport={downloadAdmissionDetails} />

        {/* Data Table */}
        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
          pageFilters={pageFilters}
          handleFliterSliceChange={handleFliterSliceChange}
        />
      </Box>
      <AdmissionModal refetch={fetchDetails} open={admissionOpen} handleClose={handleClose} formData={formData} setFormData={setFormData} />
    </>
  )
}

export default Admission
